module.exports = __webpack_public_path__ + "static/img/29a.1e961c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/29a.jpg
// module id = tSoC
// module chunks = 1